
























import Vue from "vue";
export default Vue.extend({
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    labelClass: {
      type: String
    },
    modelValue: {
      type: [String, Number],
      default: ""
    }
  },
  computed: {
    checked(): boolean {
      return this.modelValue == this.value;
    }
  }
});
